import React from 'react';
import { Box, Typography } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import { CompletionScreenProps } from '../types';

export const CompletionScreen: React.FC<CompletionScreenProps> = ({ language }) => {
  const getThankYouText = (): string => {
    return language === 'no' ? 'Takk!' : 'Thank you!';
  };

  const getCompletionMessage = (): string => {
    return language === 'no'
      ? 'Din tilbakemelding har blitt sendt inn.'
      : 'Your feedback has been submitted successfully.';
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        width: '100%',
        py: 4,
      }}
    >
      <CheckCircle
        sx={{
          fontSize: 64,
          color: 'success.main',
          mb: 3,
        }}
      />

      <Typography variant="h4" sx={{ mb: 2, fontWeight: 600 }}>
        {getThankYouText()}
      </Typography>

      <Typography variant="body1" sx={{ mb: 4, maxWidth: 400, color: 'text.secondary' }}>
        {getCompletionMessage()}
      </Typography>
    </Box>
  );
};
